require('./style.less');

var Marionette = require('marionette'),
    IndexesView = require('./collectionView');

module.exports = Marionette.LayoutView.extend({ //todo: inherit from subpanel subcontent (notes)
    className: 'spWr',
    template: require('./indexLayout.hbs'),
    regions: {
        header:     '.sp-header', //-- (unused)
        body:       '.sp-body'
    },
    onRender: function () {
        this.getRegion('body').show(new IndexesView({
            collection: this.options.collection
        }));
    },
    destroy: function () {
        Marionette.LayoutView.prototype.destroy.apply(this, arguments);
        /* remove jq cache references -- still unsure why these are still referenced .... */
        this.$('*').remove();

    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/index/view/layout/layout.js
 ** module id = 573
 ** module chunks = 0
 **/